export enum ReferralDonorSituation {    
    DirectedDonor = 1,
    NonDirectedDonor = 2
}